import { render, staticRenderFns } from "./direct.vue?vue&type=template&id=209b5871&scoped=true"
import script from "./direct.vue?vue&type=script&lang=js"
export * from "./direct.vue?vue&type=script&lang=js"
import style0 from "./direct.vue?vue&type=style&index=0&id=209b5871&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209b5871",
  null
  
)

export default component.exports